import React from 'react';
import PropTypes from 'prop-types';

import { CarouselItemMatcher } from 'components/carousel/shapes';
import { CarouselNavigationItem } from 'components/carousel/CarouselNavigationItem';

const CarouselNavigation = ({ children, activate }) => (
  <div className='carousel-preview-navigation mt-mini row no-gutters'>
    {children.map((carouselItem) => (
      <CarouselNavigationItem
        key={carouselItem.props.previewImageUrl}
        activate={activate}
        {...carouselItem.props}
      />
    ))}
  </div>
);

CarouselNavigation.propTypes = {
  children: CarouselItemMatcher,
  activate: PropTypes.func.isRequired
};

export { CarouselNavigation };
